import CheckCircleIcon from '@mui/icons-material/CheckCircle';
import InfoIcon from '@mui/icons-material/Info';
import CROSS_BLACK_ICON from '@mui/icons-material/Clear';
import { connect, useDispatch, useSelector } from 'react-redux';
import MarkDownContent from '../../pages/Journal/MarkDownContent';
import Tooltip from '@mui/material/Tooltip';
import { analyticsView } from "../Helpers/Common";
const GenericCard = ({ data }) => {
    const analyticsCardsDetails = useSelector((state) => state.analyticsReducer.card_details || []);
    // document.querySelectorAll('.flip-trigger').forEach(trigger => {
    //     trigger.addEventListener('mousedown', function () {
    //         const card = this.closest('.flip-card');
    //         card.classList.add('active');
    //         setTimeout(() => {
    //             card.classList.remove('active');
    //         }, 2000);
    //     });
    // });
    document.querySelectorAll('.flip-trigger').forEach(trigger => {
        trigger.addEventListener('mousedown', function () {
            // Remove 'active' class from all cards
            document.querySelectorAll('.flip-card.active').forEach(card => {
                card?.classList?.remove('active');
            });

            // Add 'active' class to the clicked card
            const card = this.closest('.flip-card');
            card?.classList?.add('active');

            //Remove it after 5 seconds
            // setTimeout(() => {
            //     card.classList.remove('active');
            // }, 5000);
        });
    });
    document.querySelectorAll('.flip-triggerClosed').forEach(trigger => {
        trigger.addEventListener('click', function () {
            // Remove 'active' class from all cards
            document.querySelectorAll('.flip-card.active').forEach(card => {
                card?.classList?.remove('active');
            });
        });
    });
    return (
        <div>
            <div className="grid grid-cols-1 lg:grid-cols-3 xl:grid-cols-4 gap-4 pb-4">
                {[1, 2, 3, 4].map((card, index) => (
                    <div key={index} className="flip-card h-72">
                        <div className="flip-card-inner border20px shadow-sm cardBackgroundColor">
                            {/* Front */}
                            <div className="flip-card-front">
                                {index === 0 && (
                                    <>
                                        <h3 className="text-xl blackColor text-center font-bold mb-1">My Showcase <Tooltip title={analyticsView} placement="top" arrow>
                                            <span><InfoIcon className='flip-trigger cursor-pointer primaryIcon' /></span>
                                        </Tooltip></h3>
                                        <p className="DPStatisticsCount font-bold text-center blueColor mb-1">{data?.my_showcase?.published_showcases || 0}</p>
                                        <p className="text-lg font-medium text-center lightColor mb-2 ">Published Showcases</p>
                                        <div className='px-10 mt-2'>
                                            <div className='flex justify-between'>
                                                <p className="flex items-center text-base lightColor">Profile Picture</p>
                                                {data?.my_showcase?.profile_picture === 1 ? <CheckCircleIcon className="primaryIcon" /> : <CheckCircleIcon className='secondaryIcon' />}
                                            </div>
                                            <div className='flex justify-between'>
                                                <p className="flex items-center text-base lightColor">About Me</p>
                                                {data?.my_showcase?.about_me === 1 ? <CheckCircleIcon className="primaryIcon" /> : <CheckCircleIcon className='secondaryIcon' />}
                                            </div>
                                            <div className='flex justify-between'>
                                                <p className="flex items-center text-base lightColor">Pinned Reflection</p>
                                                {data?.my_showcase?.pinned_reflection === 1 ? <CheckCircleIcon className="primaryIcon" /> : <CheckCircleIcon className='secondaryIcon' />}
                                            </div>
                                        </div>
                                        <p className="text-sm lightColor mt-auto">{analyticsCardsDetails?.filter(x => x.card_name == "ga_my_showcase")[0]?.simple_description}</p>
                                    </>
                                )}
                                {index === 1 && (
                                    <>
                                        <h3 className="text-xl blackColor text-center font-bold mb-1">My Journal <Tooltip title={analyticsView} placement="top" arrow>
                                            <span><InfoIcon className='flip-trigger cursor-pointer primaryIcon' /></span>
                                        </Tooltip></h3>
                                        <p className="DPStatisticsCount font-bold text-center blueColor mb-1">{data?.my_journal?.total_reflections || 0}</p>
                                        <p className="text-lg font-medium text-center lightColor mb-2">Reflections Written</p>
                                        <div className='px-10 mt-2'>
                                            <div className='flex justify-between'>
                                                <p className="flex items-center text-base lightColor">Total words</p>
                                                <strong className="CardHeader">{data?.my_journal?.total_words || 0}</strong>
                                            </div>
                                            <div className='flex justify-between'>
                                                <p className="flex items-center text-base lightColor">Average words</p>
                                                <strong className="CardHeader">{data?.my_journal?.average_words || 0}</strong>
                                            </div>
                                            <div className='flex justify-between'>
                                                <p className="flex items-center text-base lightColor">Tagged courses</p>
                                                <strong className="CardHeader">{data?.my_journal?.tagged_courses || 0}</strong>
                                            </div>
                                        </div>
                                        <p className="text-sm lightColor mt-auto">{analyticsCardsDetails?.filter(x => x.card_name == "ga_my_journal")[0]?.simple_description}</p>
                                    </>
                                )}
                                {index === 2 && (
                                    <>
                                        <h3 className="text-xl blackColor text-center font-bold mb-1">DP Tasks <Tooltip title={analyticsView} placement="top" arrow>
                                            <span><InfoIcon className='flip-trigger cursor-pointer primaryIcon' /></span>
                                        </Tooltip></h3>
                                        <p className="DPStatisticsCount font-bold text-center blueColor mb-1">{data?.dp_tasks?.completed_percentage || 0}%</p>
                                        <p className="text-lg font-medium text-center lightColor mb-2">DP Tasks</p>
                                        <div className='px-10 mt-2'>
                                            <div className='flex justify-between'>
                                                <p className="flex items-center text-base lightColor">Task Lists</p>
                                                <strong className="CardHeader">{data?.dp_tasks?.task_lists || 0}</strong>
                                            </div>
                                            <div className='flex justify-between'>
                                                <p className="flex items-center text-base lightColor">Total Tasks</p>
                                                <strong className="CardHeader">{data?.dp_tasks?.total_tasks || 0}</strong>
                                            </div>
                                            <div className='flex justify-between'>
                                                <p className="flex items-center text-base lightColor">Completed</p>
                                                <strong className="CardHeader">{data?.dp_tasks?.completed || 0}</strong>
                                            </div>
                                        </div>
                                        <p className="text-sm lightColor mt-auto">{analyticsCardsDetails?.filter(x => x.card_name == "ga_dp_tasks")[0]?.simple_description}</p>
                                    </>
                                )}
                                {index === 3 && (
                                    <>
                                        <h3 className="text-xl blackColor text-center font-bold mb-1">Community <Tooltip title={analyticsView} placement="top" arrow>
                                            <span><InfoIcon className='flip-trigger cursor-pointer primaryIcon' /></span>
                                        </Tooltip></h3>
                                        <p className="DPStatisticsCount font-bold text-center blueColor mb-1">{data?.community?.total_reflections_shared || 0}</p>
                                        <p className="text-lg font-medium text-center lightColor mb-2">Reflections Shared </p>
                                        <div className='px-10 mt-2'>
                                            <div className='flex justify-between'>
                                                <p className="flex items-center text-base lightColor">To Individuals</p>
                                                <strong className="CardHeader">{data?.community?.shared_to_individual || 0}</strong>
                                            </div>
                                            <div className='flex justify-between'>
                                                <p className="flex items-center text-base lightColor">To Groups</p>
                                                <strong className="CardHeader">{data?.community?.shared_to_groups || 0}</strong>
                                            </div>
                                            <div className='flex justify-between'>
                                                <p className="flex items-center text-base lightColor">To Showcases</p>
                                                <strong className="CardHeader">{data?.community?.shared_to_showcases || 0}</strong>
                                            </div>
                                        </div>
                                        <p className="text-sm lightColor mt-auto">{analyticsCardsDetails?.filter(x => x.card_name == "ga_community")[0]?.simple_description}</p>
                                    </>
                                )}
                            </div>

                            {/* Back */}
                            <div className="flip-card-back bg-opacity-80">
                                {index === 0 && (<>
                                    <div className=''>
                                        <button
                                            className="cursor-pointer hover:opacity-60 float-right flip-triggerClosed text-xl font-bold"
                                        >&times;
                                        </button>
                                        <h3 className="text-xl font-semibold mb-2">My Showcase</h3>
                                    </div>
                                    <div className="overflow-y-auto custom-scrollbar">
                                        <p className="text-sm text-justify pt-3 px-5">
                                            {analyticsCardsDetails?.filter(x => x.card_name == "ga_my_showcase")[0]?.is_html_content ?
                                                <MarkDownContent htmlContent={analyticsCardsDetails?.filter(x => x.card_name == "ga_my_showcase")[0]?.full_description} className={false} /> :
                                                analyticsCardsDetails?.filter(x => x.card_name == "ga_my_showcase")[0]?.full_description}
                                        </p>
                                    </div>
                                </>)}
                                {index === 1 && (<>
                                    <div className=''>
                                        <button
                                            className="cursor-pointer hover:opacity-60 float-right flip-triggerClosed text-xl font-bold"
                                        >&times;
                                        </button>
                                        <h3 className="text-xl font-semibold mb-2">My Journal</h3>
                                    </div>
                                    <div className="overflow-y-auto custom-scrollbar">
                                        <p className="text-sm text-justify pt-3 px-5">
                                            {analyticsCardsDetails?.filter(x => x.card_name == "ga_my_journal")[0]?.is_html_content ?
                                                <MarkDownContent htmlContent={analyticsCardsDetails?.filter(x => x.card_name == "ga_my_journal")[0]?.full_description} className={false} /> :
                                                analyticsCardsDetails?.filter(x => x.card_name == "ga_my_journal")[0]?.full_description}
                                        </p>
                                    </div>
                                </>)}
                                {index === 2 && (<>
                                    <div className=''>
                                        <button
                                            className="cursor-pointer hover:opacity-60 float-right flip-triggerClosed text-xl font-bold"
                                        >&times;
                                        </button>
                                        <h3 className="text-xl font-semibold mb-2">DP Tasks</h3>
                                    </div>
                                    <div className="overflow-y-auto custom-scrollbar">
                                        <p className="text-sm text-justify pt-3 px-5">
                                            {analyticsCardsDetails?.filter(x => x.card_name == "ga_dp_tasks")[0]?.is_html_content ?
                                                <MarkDownContent htmlContent={analyticsCardsDetails?.filter(x => x.card_name == "ga_dp_tasks")[0]?.full_description} className={false} /> :
                                                analyticsCardsDetails?.filter(x => x.card_name == "ga_dp_tasks")[0]?.full_description}
                                        </p>
                                    </div>
                                </>)}
                                {index === 3 && (<>
                                    <div className=''>
                                        <button
                                            className="cursor-pointer hover:opacity-60 float-right flip-triggerClosed text-xl font-bold"
                                        >&times;
                                        </button>
                                        <h3 className="text-xl font-semibold mb-2">Community</h3>
                                    </div>
                                    <div className="overflow-y-auto custom-scrollbar">
                                        <p className="text-sm text-justify pt-3 px-5">
                                            {analyticsCardsDetails?.filter(x => x.card_name == "ga_community")[0]?.is_html_content ?
                                                <MarkDownContent htmlContent={analyticsCardsDetails?.filter(x => x.card_name == "ga_community")[0]?.full_description} className={false} /> :
                                                analyticsCardsDetails?.filter(x => x.card_name == "ga_community")[0]?.full_description}
                                        </p>
                                    </div>
                                </>)}
                            </div>

                        </div>
                    </div>
                ))}
            </div>
        </div>
    );
};

export default GenericCard;
